import { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import { PP } from 'helpers/date';
import { getDeviceInformation } from 'helpers/device';

import {
  getDeviceLastActivityFormattedDate,
  getDeviceLocation,
} from '../../helpers';
import DeviceStatusBadge from '../DeviceStatusBadge';
import { getIconName } from './helpers';
import locales from './locales';
import { Props } from './types';

const Device: FC<Props> = ({ device, onSelect, selectedDevice }) => {
  const iconName = getIconName(device);
  const lastActivityDate = getDeviceLastActivityFormattedDate(device, PP);

  const currentDevice = getDeviceInformation();
  const isCurrentDevice = currentDevice.token === device.token;

  const location = getDeviceLocation(device);

  const getDeviceDescription = () => {
    const description = lastActivityDate
      ? `${device.model}  •  ${lastActivityDate}`
      : device.model;

    return isCurrentDevice ? locales.thisDevice : description;
  };

  return (
    <SunshineCard
      alignItems="center"
      isActive={device.token === selectedDevice?.token}
      onClick={() => onSelect?.(device)}
    >
      <SunshineCard.Slot name="aside">
        <SquircleIcon name={iconName} />
      </SunshineCard.Slot>

      <SunshineCard.Content>
        <SunshineCard.Title>{device.name}</SunshineCard.Title>
        <SunshineCard.Text>{getDeviceDescription()}</SunshineCard.Text>
        {location ? <SunshineCard.Text>{location}</SunshineCard.Text> : null}
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        <DeviceStatusBadge device={device} />
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default Device;
